import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
export var resizeGroupStyles = {
    flex: 1,
    overflow: 'hidden'
};
export var actionsGroupResizeGroupContainer = {
    display: 'flex',
    justifyContent: 'flex-end'
};
export var actionsGroupOverflowSetStyles = {
    root: {
        justifyContent: 'flex-end'
    }
};
var buttonWidth = 48;
export var getStylesInternal = memoizeFunction(function (numRightItems, isSearchEnabled, theme) {
    return mergeStyleSets({
        root: {
            backgroundColor: theme === null || theme === void 0 ? void 0 : theme.palette.themePrimary,
            fontFamily: "'Segoe UI', 'Segoe UI Web(West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', 'sans-serif'",
            alignItems: 'center',
            height: '48px',
            display: 'grid',
            gridTemplateColumns: '1fr 468px 1fr',
            borderBottom: '1px solid transparent',
            boxSizing: 'border-box',
            selectors: {
                '@media (min-width:1366px) and (max-width: 1920px)': {
                    gridTemplateColumns: '1fr 468px 1fr'
                },
                '@media (min-width:1024px) and (max-width: 1365px)': {
                    gridTemplateColumns: '1fr 468px 1fr'
                },
                '@media (min-width:640px) and (max-width: 1023px)': {
                    gridTemplateColumns: '1fr 274px 1fr'
                },
                '@media (min-width: 320px) and (max-width: 639px)': {
                    gridTemplateColumns: '1fr ' + buttonWidth + 'px ' + numRightItems * buttonWidth + 'px'
                },
                '@media (max-width: 320px)': {
                    gridTemplateColumns: '1fr ' + buttonWidth + 'px ' + numRightItems * buttonWidth + 'px'
                }
            }
        },
        titleContainer: {
            height: '100%',
            paddingLeft: '16px',
            paddingRight: '12px',
            alignSelf: 'center',
            fontSize: '16px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            gridColumnStart: '1',
            gridColumnEnd: isSearchEnabled ? '1' : '3'
        },
        searchBoxContainer: {
            alignSelf: 'center',
            gridColumnStart: '2',
            gridColumnEnd: '2'
        },
        floatingSearchRoot: {
            width: '100%',
            backgroundColor: theme === null || theme === void 0 ? void 0 : theme.palette.themePrimary
        },
        rightItemsContainer: {
            height: '48px',
            overflow: 'hidden',
            gridColumnStart: '3',
            gridColumnEnd: '3'
        },
        overflowSet: {}
    });
});
//# sourceMappingURL=HeaderBanner.styles.js.map